module.exports = __webpack_public_path__ + "static/media/sns_ja.805d2d48.svg";